import { render } from "./BaseRadio.vue?vue&type=template&id=3cd9af80&ts=true"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__